import { render, staticRenderFns } from "./temporaryStop.vue?vue&type=template&id=2844a61e&scoped=true&"
import script from "./temporaryStop.vue?vue&type=script&lang=js&"
export * from "./temporaryStop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2844a61e",
  null
  
)

export default component.exports